import { FlexRow, FlexCol } from "src/utils/flexLayouts";
import { FileIconGray } from "./ui-icons/upload/FileIcon";

export function EmptyList({ icon, title }: { icon?: JSX.Element; title: string }) {
  return (
    <FlexRow className="p-4 tablet:pt-4 place-content-center">
      <FlexCol>
        <FlexRow className="mb-2.5 justify-center">{icon ?? <FileIconGray />}</FlexRow>
        <FlexRow className="text-center tablet:text-left text-[14px] tablet:text-base font-medium">{title}</FlexRow>
      </FlexCol>
    </FlexRow>
  );
}
